import {
  FilterDefaultVisibility,
  FilterSelectionMode,
  FilterSource,
} from "./types";

export const FILTER_SOURCE_LABELS: Record<FilterSource, string> = {
  [FilterSource.Static]: "Static",
  [FilterSource.Query]: "Query",
};

export const FILTER_SELECTION_MODE_LABELS: Record<FilterSelectionMode, string> =
  {
    [FilterSelectionMode.Single]: "Single",
    [FilterSelectionMode.Multi]: "Multi",
  };

export const FILTER_DEFAULT_VISIBILITY_LABELS: Record<
  FilterDefaultVisibility,
  string
> = {
  [FilterDefaultVisibility.VisibleToAll]: "Visible to all",
  [FilterDefaultVisibility.HiddenByDefault]: "Hidden by default",
};
